export const PostalRepository = () => {
  const search = (code: string) => {
    const url = "https://apis.postcode-jp.com/api/v5/postcodes/" + code;
    return new Promise((res, rej) => {
      fetch(url, {
        headers: {
          "Content-Type": "application/json",
          apikey: "sWRYtttmsvq1nTAY5F0qPtSYymlryrH5pajz0Fc",
        },
        method: "GET",
      })
        .then((response: Response) => {
          if (!response.ok) {
            throw new Error();
          }
          return response.json();
        })
        .then((data) => {
          if (data.length > 0) {
            res(data[0]);
          } else {
            rej("存在しない郵便番号です");
          }
        });
    });
  };

  return {
    search,
  };
};
